import { defineComponent as _defineComponent } from 'vue'
import { computed, provide, useSlots, VNode } from 'vue';
import { isNil } from '@/utils/misc';
import { useI18n } from '@/composables/i18n';

type MenuPosition =
  | 'is-top-right'
  | 'is-top-left'
  | 'is-bottom-left'
  | 'is-bottom-right';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TableActionsList',
  props: {
    position: { default: 'is-bottom-left' },
    type: { default: 'row' },
    icon: { default: 'dots-horizontal' },
    disabled: { type: Boolean, default: false }
  },
  emits: ['row-menu-active-change'],
  setup(__props: any, { emit }) {

const props = __props as { position: MenuPosition, type: 'selection' | 'row', icon: string, disabled: boolean };





const $slots = useSlots();
const { t } = useI18n();

const visibleSlots = computed<VNode[]>(() => {
  const slots = $slots.default?.() ?? [];
  return slots.filter(
    (slot) => (slot.componentOptions?.propsData as any)?.hidden !== true,
    // as TableActionButton
  );
});

const hasMultipleActions = computed<boolean>(
  () =>
    visibleSlots.value
      // Slots removed with v-if still show up in the list,
      // but with undefined values on all fields
      .filter((slot) => !isNil(slot.tag)).length > 1,
);

const shouldUseMenu = computed(() => {
  return hasMultipleActions.value || props.type === 'selection';
});
provide('shouldUseMenu', shouldUseMenu);

// This event is only emitted as a workaround to click propagation issue with
// row action menus. It doesn't have any other use.
function emitWorkaroundEvent(event: any) {
  emit('row-menu-active-change', event);
}

return { __sfc: true,props, emit, $slots, t, visibleSlots, hasMultipleActions, shouldUseMenu, emitWorkaroundEvent }
}

})